module.exports = __webpack_public_path__ + "static/img/wavm8s-021-risik.c4dfa08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wav/wavm8s-021-risik.png
// module id = fndK
// module chunks = 0